export function isFetchingSchemaInterface(schema) {
    return schema.url !== undefined;
}
export var PayloadType;
(function (PayloadType) {
    PayloadType["SEND"] = "send";
    PayloadType["RECEIVE"] = "receive";
    PayloadType["REQUEST"] = "request";
    PayloadType["REPLY"] = "reply";
})(PayloadType || (PayloadType = {}));
export var PluginSlot;
(function (PluginSlot) {
    PluginSlot["OPERATION"] = "operation";
    PluginSlot["INFO"] = "info";
})(PluginSlot || (PluginSlot = {}));
//# sourceMappingURL=types.js.map